var map = {
	"./Back.svg": 540,
	"./BackWhite.svg": 541,
	"./Burger_icon.svg": 542,
	"./Plus_icon_Normal.svg": 543,
	"./Twitter-s-icon.svg": 1194,
	"./Twitter-s-icon_2.svg": 544,
	"./arrow_icon.svg": 545,
	"./arrow_left_normal_icon.svg": 220,
	"./arrow_right_normal_icon.svg": 221,
	"./back_arrow_icon.svg": 1195,
	"./blue_arrow.svg": 546,
	"./booster_icon.svg": 1196,
	"./calculator_icon.svg": 1197,
	"./calculator_icon_hover.svg": 1198,
	"./calculator_icon_light_mode.svg": 1199,
	"./calendar_inactive_icon.svg": 1200,
	"./calender_Forward_icon_inactive.svg": 277,
	"./calender_back_icon_inactive.svg": 278,
	"./copy-icon.svg": 1201,
	"./discord-s-icon.svg": 547,
	"./email.svg": 1202,
	"./facebook-s-icon.svg": 1203,
	"./fld_bi.svg": 1204,
	"./fld_bi_c.svg": 1205,
	"./fld_bi_gray.svg": 548,
	"./fld_bi_white.svg": 362,
	"./fldw_bi.svg": 1206,
	"./gas-graphic.svg": 1207,
	"./hover/discord-s-hover-icon.svg": 549,
	"./hover/medium-s-hover-icon.svg": 550,
	"./hover/telegram-s-hover-icon.svg": 551,
	"./hover/twitter-s-hover-icon.svg": 552,
	"./hover/website-s-hover-icon.svg": 553,
	"./input_question_icon.svg": 53,
	"./linkedin-s-icon.svg": 1208,
	"./list-close_icon-hover.svg": 1209,
	"./list-close_icon.svg": 1210,
	"./list-close_icon_light.svg": 1211,
	"./list-open_icon-hover.svg": 1212,
	"./list-open_icon.svg": 1213,
	"./m_Burger_icon.svg": 438,
	"./mail.svg": 1214,
	"./medium-s-icon.svg": 554,
	"./metamask.svg": 1215,
	"./minus_icon_Normal.svg": 555,
	"./poll-time-active-icon.svg": 1216,
	"./poll_time_active_icon.svg": 556,
	"./popup_close_icon.svg": 557,
	"./resources_icon.svg": 1217,
	"./resources_icon_blue.svg": 1218,
	"./select1_arrow_inactive.svg": 558,
	"./setting_icon_hover.svg": 559,
	"./setting_icon_normal.svg": 560,
	"./sicon-user_guide.svg": 1219,
	"./swap-arrow-icon.svg": 279,
	"./telegram-s-icon.svg": 561,
	"./tick-icon.svg": 562,
	"./tokamak_favicon.svg": 563,
	"./tooltip_icon_white.svg": 564,
	"./top_arrow_icon-w.svg": 1220,
	"./top_arrow_icon.svg": 1221,
	"./tos_symbol.svg": 280,
	"./trezor.png": 1222,
	"./trezor.svg": 1223,
	"./ts_bi_c.svg": 565,
	"./walletconnect.svg": 1224,
	"./website-s-icon.svg": 566,
	"./youtube-s-icon.svg": 1225,
	"./◢ Resizer.svg": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;